<template>
  <app-wrapper>
    <transition appear name="fadeout">
      <v-layout column align-center justify-center class="mb-5">
        <v-alert outlined type="success" :value="true">
          <div class="title">You have updated your password.</div>
        </v-alert>
        <div v-if="!isAuthenticated">
          <transition appear name="fadeout">
            <v-btn color="#54318F" dark large @click="navSignIn()">Sign In</v-btn>
          </transition>
        </div>
      </v-layout>
    </transition>
  </app-wrapper>
</template>

<script>
import wrapper from './wrapper'
import router from '../router'

export default {
  components: {
    'app-wrapper': wrapper
  },
  computed: {
    isAuthenticated() {
      return this.$store.state.auth.isAuthenticated
    }
  },
  methods: {
    navSignIn: function () {
      console.log('navigating to sign in')
      router.push('/login')
    }
  }
}
</script>
<style>
</style>
